/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2017 Adobe
 *  All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

import React from 'react';
import {useIntl} from 'react-intl';
import {DiscoverUtils, DiscoverAnalytics} from 'discover-hub';
import {SideNav, SideNavItem} from '@react/react-spectrum/SideNav';

/* eslint-enable no-unused-vars */

type Props = {
	filterState?: any;
	items: any;
	onDiscoverPathChange: Function;
	currentTab: any;
	postAnalytics: Function;
};

const DiscoverLeftNav = ({filterState, items, onDiscoverPathChange, currentTab, postAnalytics}: Props) => {
	const intl = useIntl();
	// onClick function -> call parent onClick but also set new state of currentTab so leftnav renders
	const onClickHandler = (key) => {
		onDiscoverPathChange([
			DiscoverUtils.getTopicSignal('all-topics'),
			DiscoverUtils.getPageSignal(0),
			DiscoverUtils.getNavSignal(key),
		]);

		postAnalytics(DiscoverAnalytics.postDiscoverNavigationClick(key));
	};

	/**
	 * Detect key press
	 * @param {any} event
	 * @param {bool} stopPropagation Stop propagation of a child event to parent
	 */
	const onKeyDown = (event, stopPropagation = false) => {
		if (event.key === 'Enter' || event.which === 13) {
			if (stopPropagation) {
				event.stopPropagation();
			}
			event.currentTarget.click();
		}
	};

	return (
		<div className='discover-left-nav'>
			<SideNav value={currentTab}>
				{items.map((item, index) => (
					<SideNavItem
						key={index}
						value={item.key}
						onClick={() => onClickHandler(item.key)}
						onKeyDown={event => onKeyDown(event, true)}
						label={intl.formatMessage({id: item.label})}
						expanded={item.key === filterState}
					/>
				))}
			</SideNav>
		</div>
	);
};

export default DiscoverLeftNav;
